import axios from "axios";
import { NeulgoSdk, useAuthStore } from "@broanex/utils";
import { useSuccessMessageStore } from "../stores/successMessageStore";

export const baseURL = "https://homepage-api.neulgo.com";

// Axios 인스턴스 생성
const api = axios.create({
    baseURL: baseURL,
});

// Request interceptor
api.interceptors.request.use(
    function (config) {
        const { user } = useAuthStore.getState();

        if (user) {
            config.headers.Authorization = `Bearer ${user.accessToken}`;
        }

        return config;
    },
    function (error) {
        throw error;
    }
);

// Response interceptor
api.interceptors.response.use(
    function (response) {
        if (response.status >= 200 && response.status < 300) {
            const { message, callback } = useSuccessMessageStore.getState();
            if (message) {
                alert(message);
            }
            if (callback) {
                callback();
            }
            useSuccessMessageStore.getState().reset();
        }
        return response;
    },
    async function (error) {
        const { logout, setUser, user } = useAuthStore.getState();
        const { reset } = useSuccessMessageStore.getState();

        reset();

        if (!error.config) {
            return Promise.reject(error);
        }

        if (
            error.response?.status === 401 &&
            (error.response?.data?.message === "Token is invalid" ||
                error.response?.data?.message === "User is invalid" ||
                error.response?.data?.message === "Token is expired")
        ) {
            if (!error.config.retry) {
                try {
                    const refreshUser = await NeulgoSdk.getRefreshUser(user.refreshToken);
                    if ("redirectUrl" in refreshUser) {
                        window.location.href = refreshUser.redirectUrl;
                        return;
                    }
                    setUser(refreshUser);
                    error.config.headers.Authorization = `Bearer ${refreshUser.accessToken}`;
                    error.config.retry = true;
                    return api.request(error.config);
                } catch (refreshError) {
                    console.log(refreshError, "refresh error");
                    logout();
                }
            }
        }

        const errorMessage = error?.response?.data?.message || "알 수 없는 오류가 발생하였습니다.";
        alert(errorMessage);

        return Promise.reject(error);
    }
);

export default api;
